import { Tooltip } from '@mui/material';
import { Avatar } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { stringAvatar } from 'shared-utils';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	interviewedBy: {
		name: string;
		img: string;
		company: string;
		role: string;
		linkedinUrl: string;
	};
}

const TechnicalRoundInterviewedBy = ({ interviewedBy }: Props) => {
	const { isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();

	const companyRoleString = `${interviewedBy.company} I ${interviewedBy.role}`;
	const [maxLength, setMaxLength] = useState(0);

	const showLinkedinIcon = !!interviewedBy.linkedinUrl;

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(18);
		} else {
			setMaxLength(15);
		}
	}, []);

	return (
		<div
			className={`sm:pb-5 sm:border-b-[1px] sm:border-solid sm:border-[#00CFDE] md:pl-[10px] md:border-solid md:border-[#00CFDE] ${
				isRecruiterLoggedIn || isAccountManagerLoggedIn ? 'md:border-l-[1px]' : ''
			}`}
		>
			{/* <div className="sm:pb-5 sm:border-b-[1px] sm:border-solid sm:border-[#00CFDE] md:pl-[10px]  md:border-solid md:border-[#00CFDE]"> */}
			<div className="text-sm dark:text-[#E5FFFF] text-[#28293D]">Interviewed by</div>

			<div className="mt-3 flex gap-2 items-center">
				<div>
					<Avatar
						bordered
						rounded
						img={interviewedBy.img}
						placeholderInitials={stringAvatar(interviewedBy.name.trim().toUpperCase() || '')}
					/>
				</div>
				<div>
					<div className="text-base font-medium dark:text-white text-[#28293D] cursor-default">
						{interviewedBy.name.length > maxLength ? (
							<Tooltip title={interviewedBy.name}>
								<span
									onClick={e => {
										e.stopPropagation();
									}}
								>
									{interviewedBy.name.substring(0, maxLength)}...
								</span>
							</Tooltip>
						) : (
							<>{interviewedBy.name}</>
						)}

						{showLinkedinIcon ? (
							<BsLinkedin
								onClick={() => {
									window.open(interviewedBy.linkedinUrl, '_blank');
								}}
								className="ml-[6px] inline rounded-[1px] cursor-pointer bg-white text-[#7777E7]"
								size={12}
							/>
						) : null}
					</div>

					<div className="text-sm dark:text-[#E4E4EB] text-[#28293D] cursor-default">
						{companyRoleString.length > maxLength ? (
							<>
								<Tooltip title={companyRoleString}>
									<span
										onClick={e => {
											e.stopPropagation();
										}}
									>
										{companyRoleString.substring(0, maxLength)}...
									</span>
								</Tooltip>
							</>
						) : (
							<>{companyRoleString}</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default TechnicalRoundInterviewedBy;
